import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddSexes, Sexes } from '../models/sexes/sexes';


@Injectable({
  providedIn: 'root'
})
export class SexesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getSexes(SexesId?: number): Observable<Sexes[]>{
        return this._http.get<Sexes[]>(`${environment.api.url}/Sexes?SexesId=${SexesId??''}`);
    }
  
    public deleteSexes(SexesId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Sexes/${SexesId}`);
    }
  
    public addSexes(model: AddSexes): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Sexes`, model);
    }
}
